import type ContextMenuViewState from '../store/schema/ContextMenuViewState';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export default function getContextMenuViewStateForItem(
    scenarioId: CalendarPickerScenarioId,
    itemId: string
): ContextMenuViewState | null {
    const store = getCalendarPickerStore(scenarioId);
    let contextMenuViewState = null;

    if (store.contextMenu) {
        contextMenuViewState = store.contextMenu.itemId === itemId ? store.contextMenu : null;
    }

    return contextMenuViewState;
}
